module.exports = __webpack_public_path__ + "media/images/city/070-galata-tower-5f75bd6f41b5381ef3d57e2c5773a7e8.svg";